import {fullReady, HadronCollider} from "@webreact/webreactor";

__webpack_public_path__ = document.head.querySelector('meta[name="base_assets"]').content;

const router = new HadronCollider([{
    target: '[data-component="opening_times-small"]',
    file: async () => (await import('./Components/OpeningTimesSmall')).default,
}])

router.loadEvents()

/**
 * Fire this function when the document is fully loaded.
 * It takes no parameters and should return nothing.
 *
 * @return void
 */
function loaded() {
}

fullReady(loaded);
